import { useQuery } from "@apollo/react-hooks";

import { Lesson } from "@hubcapp/types";

import ViewLessonModalDataQuery from "../graph-ql/getViewLessonModalData.graphql";

const useViewLessonModalData = (id?: string) =>
  useQuery<{ lesson: Lesson }>(ViewLessonModalDataQuery, {
    variables: {
      id,
    },
    skip: !id,
  });

export default useViewLessonModalData;
